// Editorial data for The Journal — wireframe placeholders
export const journal = [
  {
    slug: "the-gap",
    volume: "Volume I",
    number: "N°01",
    date: "Winter 2026",
    category: "Essay",
    title: "The Gap Between the Boardroom and the Floor",
    dek: "Where strategy dies, or begins to live. A reflection on the distance between what a brand promises and what a guest feels.",
    author: "Natalia Jaramillo",
    readTime: "8 min",
    cover:
      "https://images.unsplash.com/photo-1762423656649-24aaf046402e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxlZGl0b3JpYWwlMjBqb3VybmFsJTIwZGVzayUyMHN0aWxsJTIwbGlmZSUyMGx1eHVyeXxlbnwwfHx8fDE3ODQxNjgxNzN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "humanistic-luxury",
    volume: "Volume I",
    number: "N°02",
    date: "Autumn 2025",
    category: "Manifesto",
    title: "Humanistic Luxury — A Method, Not a Trend",
    dek: "Why the future of luxury will be decided by cultures, not by campaigns.",
    author: "The Editors",
    readTime: "6 min",
    cover:
      "https://images.unsplash.com/photo-1737920459846-2d0318700658?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBqb3VybmFsJTIwZGVzayUyMHN0aWxsJTIwbGlmZSUyMGx1eHVyeXxlbnwwfHx8fDE3ODQxNjgxNzN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "the-luxury-hour",
    volume: "Volume I",
    number: "N°03",
    date: "Summer 2025",
    category: "Conversation",
    title: "The Luxury Hour — On Rarity and Restraint",
    dek: "A private conversation on why the loudest brands rarely become the most lasting.",
    author: "Expert Minds Roundtable",
    readTime: "22 min",
    cover:
      "https://images.unsplash.com/photo-1601993957728-1e56ab70c5a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmUlMjBjYWxtfGVufDB8fHx8MTc4NDE2ODE3M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "the-architecture-of-luxury",
    volume: "Volume I",
    number: "N°04",
    date: "Spring 2025",
    category: "Field Note",
    title: "The Architecture of Luxury",
    dek: "Notes from the ground: how service standards become instinct, and instinct becomes culture.",
    author: "Natalia Jaramillo",
    readTime: "12 min",
    cover:
      "https://images.unsplash.com/photo-1601993957728-1e56ab70c5a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmUlMjBjYWxtfGVufDB8fHx8MTc4NDE2ODE3M3ww&ixlib=rb-4.1.0&q=85",
  },
];
